// propertySlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as propertyAPI from "./propertyAPI";

export const fetchDistrictData = createAsyncThunk(
  "property/fetchDistrictData",
  propertyAPI.fetchDistrictData
);
export const fetchSROData = createAsyncThunk(
  "property/fetchSROData",
  async (districtId) => {
    const response = await propertyAPI.fetchSROData(districtId);
    return response;
  }
);
export const fetchDeedData = createAsyncThunk(
  "property/fetchDeedData",
  propertyAPI.fetchDeedData
);
export const fetchSubdeedData = createAsyncThunk(
  "property/fetchSubdeedData",
  propertyAPI.fetchSubdeedData
);

export const fetchBookNo = createAsyncThunk(
  "property/fetchBookNo",
  propertyAPI.fetchBookNo
);

export const fetchLandRateCalculation = createAsyncThunk(
  "property/fetchLandRateCalculation",
  async ({ dcode, srocode, ratelist_year }) => {
    const response = await propertyAPI.fetchLandRateCalculation({
      dcode,
      srocode,
      ratelist_year,
    });
    return response;
  }
);

export const fetchFloorNoData = createAsyncThunk(
  "property/fetchFloorNoData",
  propertyAPI.fetchFloorNoData
);

export const fetchUnitData = createAsyncThunk(
  "property/fetchUnitData",
  propertyAPI.fetchUnitData
);

export const fetchRiderData = createAsyncThunk(
  "property/fetchRiderData",
  propertyAPI.fetchRiderData
);

export const fetchMutationDetail = createAsyncThunk(
  "property/fetchMutationDetail",
  propertyAPI.fetchMutationDetail
);

export const fetchMutationOfficeDetail = createAsyncThunk(
  "property/fetchMutationOfficeDetail",
  async ({ mutationDepartment, dcode, srocode }) => {
    const response = await propertyAPI.fetchMutationOfficeDetail({
      mutationDepartment,
      dcode,
      srocode,
    });
    return response;
  }
);

export const fetchRateListDetails = createAsyncThunk(
  "property/fetchRateListDetails",
  async ({ dcode, scocode, allcode, rateyear }) => {
    const response = await propertyAPI.fetchRateListDetails({
      dcode,
      scocode,
      allcode,
      rateyear,
    });
    return response;
  }
);

// export const insertPropertyData = createAsyncThunk(
//   "property/insertPropertyData",
//   async (propertyData) => {
//     try {
//       const response = await propertyAPI.insertPropertyData(propertyData);
//       return response;
//     } catch (error) {
//       throw error;
//     }
//   }
// );

export const insertPropertyData = createAsyncThunk(
  "property/insertPropertyData",
  async (propertyData, { rejectWithValue }) => {
    try {
      ////;
      const response = await propertyAPI.insertPropertyData(propertyData);
      console.log("insert property data =", response[0].pdE_ID);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const updatePropertyData = createAsyncThunk(
  "property/updatePropertyData",
  async (propertyData, { rejectWithValue }) => {
    try {
      ////;
      const response = await propertyAPI.updatePropertyData(propertyData);
      ////;
      console.log("update property data =", response[0].pdE_ID);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || "Something went wrong");
    }
  }
);

export const insertAreaMajData = createAsyncThunk(
  "property/insertAreaMajData",
  async (areaMajData) => {
    try {
      const response = await propertyAPI.insertAreaMajData(areaMajData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateAreaMajData = createAsyncThunk(
  "property/updateAreaMajData",
  async (areaMajData) => {
    try {
      ////;
      const response = await propertyAPI.updateAreaMajData(areaMajData);
      ////;
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchPaymentMode = createAsyncThunk(
  "property/fetchPaymentMode",
  async () => {
    console.log("fetchPaymentMode thunk called");
    const response = await propertyAPI.fetchPaymentMode();
    console.log("fetchPaymentMode thunk response:", response);
    return response;
  }
);

export const fetchRegistrationFee = createAsyncThunk(
  "property/fetchRegistrationFee",
  async ({ deedcode, subDeedCode }) => {
    const response = await propertyAPI.fetchRegistrationFee({
      deedcode,
      subDeedCode,
    });
    console.log("Registration fee=" + response);
    return response;
  }
);

export const fetchStampDuty = createAsyncThunk(
  "property/fetchStampDuty",
  async ({ deedcode, subDeedCode }) => {
    const response = await propertyAPI.fetchStampDuty({
      deedcode,
      subDeedCode,
    });
    console.log("Stamp Duty=" + response);
    return response;
  }
);

export const insertStampRegFeeData = createAsyncThunk(
  "property/insertStampRegFeeData",
  async (regFeeData) => {
    try {
      const response = await propertyAPI.insertStampRegFeeData(regFeeData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const insertPropertyEvalData = createAsyncThunk(
  "property/insertPropertyEvalData",
  async (propertyEvalData) => {
    try {
      const response = await propertyAPI.insertPropertyEvalData(
        propertyEvalData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchFloorMassResi = createAsyncThunk(
  "property/fetchFloorMassResi",
  async ({ dcode, srocode }) => {
    const response = await propertyAPI.fetchFloorMassResi({
      dcode,
      srocode,
    });
    return response;
  }
);

export const fetchFloorMassComm = createAsyncThunk(
  "property/fetchFloorMassComm",
  async ({ dcode, srocode }) => {
    const response = await propertyAPI.fetchFloorMassComm({
      dcode,
      srocode,
    });
    return response;
  }
);

export const fetchPropertyAreaResi = createAsyncThunk(
  "property/fetchPropertyAreaResi",
  async ({ dcode, srocode }) => {
    const response = await propertyAPI.fetchPropertyAreaResi({
      dcode,
      srocode,
    });
    return response;
  }
);

export const fetchConstructionTypeAndYear = createAsyncThunk(
  "property/fetchConstructionTypeAndYear",
  async ({ dcode, srocode, structclass_code }) => {
    const response = await propertyAPI.fetchConstructionTypeAndYear({
      dcode,
      srocode,
      structclass_code,
    });
    return response; // Ensure your API returns the correct data structure
  }
);

const propertySlice = createSlice({
  name: "property",
  initialState: {
    districtOptions: [],
    sroOptions: [],
    paymentOptions: [],
    registrationFeeOptions: [],
    stampDutyOptions: [],
    deedOptions: [],
    subDeedOptions: [],
    bookNoOptions: [],
    landRateCalculationOptions: [],
    rateListDetails: [],
    villageIndexOptions: [],
    villageMauzaOptions: [],
    mutationOfficeOptions: [],
    mutationOptions: [],
    floorMasOptions: [],
    floorMassResiOptions: [],
    floorMassCommOptions: [],
    propertyAreaResiOptions: [],
    subStructType: [],
    depreciationMas: [],
    unitOptions: [],
    riderOptions: [],
    rateList: [],
    insertedPropertyData: [],
    insertedStampRegFeeData: [],
    insertedPropertyEvalData: [],
    updatedPropertyData: [],
    bannedKhasra: "",
    showRatelist: false,
    status: "idle",
    error: null,
    pdE_ID: null,
  },
  reducers: {
    setShowRatelist: (state, action) => {
      state.showRatelist = action.payload;
    },
    setSelectedRate: (state, action) => {
      state.selectedRate = action.payload;
    },
    setSROOptions: (state, action) => {
      state.sroOptions = action.payload;
    },
    setpaymentOptions: (state, action) => {
      state.paymentOptions = action.payload;
    },
    setInitialPdEId: (state, action) => {
      state.pdE_ID = action.payload;
    },
    resetPropertyState: (state) => {
      // Reset all state fields to initial values
      Object.keys(state).forEach((key) => {
        if (Array.isArray(state[key])) {
          state[key] = [];
        } else if (key === "showRatelist") {
          state[key] = false;
        } else if (key === "status") {
          state[key] = "idle";
        } else {
          state[key] = null;
        }
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistrictData.fulfilled, (state, action) => {
        state.districtOptions = action.payload;
      })
      .addCase(fetchSROData.fulfilled, (state, action) => {
        state.sroOptions = action.payload;
      })
      .addCase(fetchDeedData.fulfilled, (state, action) => {
        state.deedOptions = action.payload;
      })
      .addCase(fetchSubdeedData.fulfilled, (state, action) => {
        state.subDeedOptions = action.payload;
      })
      .addCase(fetchBookNo.fulfilled, (state, action) => {
        state.bookNoOptions = action.payload[0].bookno;
        console.log("check bookNoOptions=" + state.bookNoOptions);
      })
      .addCase(fetchLandRateCalculation.fulfilled, (state, action) => {
        state.landRateCalculationOptions = action.payload;
      })
      .addCase(fetchMutationDetail.fulfilled, (state, action) => {
        state.mutationOptions = action.payload;
      })
      .addCase(fetchFloorNoData.fulfilled, (state, action) => {
        state.floorMasOptions = action.payload;
      })
      .addCase(fetchUnitData.fulfilled, (state, action) => {
        state.unitOptions = action.payload;
      })
      .addCase(fetchRiderData.fulfilled, (state, action) => {
        state.riderOptions = action.payload;
      })
      .addCase(fetchMutationOfficeDetail.fulfilled, (state, action) => {
        state.mutationOfficeOptions = action.payload;
      })
      .addCase(fetchRateListDetails.fulfilled, (state, action) => {
        state.rateListDetails = action.payload;
        state.showRatelist = true;
      })
      .addCase(insertPropertyData.fulfilled, (state, action) => {
        state.insertedPropertyData = action.payload;
        state.pdE_ID = action.payload[0].pdE_ID;
        state.status = "succeeded";
        state.error = null;
        console.log("insertPropertyData fulfilled. Response:", state.pdE_ID);
      })
      .addCase(insertPropertyData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updatePropertyData.fulfilled, (state, action) => {
        state.updatedPropertyData = action.payload;
        state.pdE_ID = action.payload[0].pdE_ID;
        state.status = "succeeded";
        state.error = null;
        console.log("updatePropertyData fulfilled. Response:", state.pdE_ID);
      })
      .addCase(updatePropertyData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(insertAreaMajData.fulfilled, (state, action) => {
        state.insertAreaMajData = action.payload;
        state.error = null;
      })
      .addCase(insertAreaMajData.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(updateAreaMajData.fulfilled, (state, action) => {
        state.updateAreaMajData = action.payload;
        state.error = null;
      })
      .addCase(updateAreaMajData.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(fetchPaymentMode.fulfilled, (state, action) => {
        console.log(
          "fetchPaymentMode fulfilled action payload:",
          action.payload
        );
        state.paymentOptions = action.payload;
      })
      .addCase(fetchRegistrationFee.fulfilled, (state, action) => {
        state.registrationFeeOptions = action.payload;
      })
      .addCase(fetchStampDuty.fulfilled, (state, action) => {
        state.stampDutyOptions = action.payload;
      })
      .addCase(fetchFloorMassResi.fulfilled, (state, action) => {
        state.floorMassResiOptions = action.payload;
      })
      .addCase(fetchFloorMassComm.fulfilled, (state, action) => {
        state.floorMassCommOptions = action.payload;
      })
      .addCase(fetchPropertyAreaResi.fulfilled, (state, action) => {
        state.propertyAreaResiOptions = action.payload;
      })
      .addCase(fetchConstructionTypeAndYear.fulfilled, (state, action) => {
        state.loading = false;
        state.subStructType = action.payload.sub_Struct_type;
        state.depreciationMas = action.payload.depreciation_mas;
      })
      .addCase(insertStampRegFeeData.fulfilled, (state, action) => {
        state.insertedStampRegFeeData = action.payload;
        state.error = null;
      })
      .addCase(insertStampRegFeeData.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(insertPropertyEvalData.fulfilled, (state, action) => {
        state.insertedPropertyEvalData = action.payload;
        state.error = null;
      })
      .addCase(insertPropertyEvalData.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export const {
  setShowRatelist,
  setSelectedRate,
  resetPropertyState,
  setInitialPdEId,
} = propertySlice.actions;

export const selectPdEId = (state) => state.property.pdE_ID;

export default propertySlice.reducer;
